export default function toDegree (angle) {
  return angle * (180 / Math.PI)
}
